/**
 * Atajo de teclado para introducir cuentas contables:
 * el usuario escribe los dígitos significativos separados por un punto
 * ("410.9") y el sistema rellena con ceros hasta alcanzar la longitud
 * estándar de la cuenta para esa empresa ("41000009").
 *
 * Si el input no contiene un punto, se devuelve sin cambios (limpio de
 * espacios). Si contiene más de un punto, se ignoran los siguientes y se
 * usan solo el primer y último tramo para no perder los dígitos.
 */
export const expandAccountShortcut = (input: string, length = 8): string => {
  if (input === null || input === undefined) return "";
  const trimmed = String(input).trim();
  if (!trimmed) return "";
  if (!trimmed.includes(".")) return trimmed;

  const parts = trimmed.split(".");
  const left = parts[0].replace(/\D/g, "");
  const right = parts[parts.length - 1].replace(/\D/g, "");

  if (!left && !right) return "";
  const total = left.length + right.length;
  if (total >= length) return (left + right).slice(0, length);

  return left + "0".repeat(length - total) + right;
};

/**
 * Deduce la longitud "estándar" de cuenta a partir de las cuentas existentes
 * (modo, la longitud que más se repite). Si no hay datos suficientes se usa
 * el `fallback` (8 dígitos por defecto, longitud típica del plan A3).
 */
export const inferAccountLength = (
  accounts: Array<string | null | undefined>,
  fallback = 8,
): number => {
  const counts = new Map<number, number>();
  for (const acc of accounts) {
    const digits = String(acc || "").replace(/\D/g, "");
    if (digits.length >= 4) {
      counts.set(digits.length, (counts.get(digits.length) || 0) + 1);
    }
  }
  let bestLen = fallback;
  let bestCount = 0;
  for (const [len, cnt] of counts) {
    if (cnt > bestCount) {
      bestLen = len;
      bestCount = cnt;
    }
  }
  return bestLen;
};
